import React, { useState } from 'react'
import {
  CRow, CCol, CCard, CCardHeader, CCardFooter,
  CButtonGroup, CButton, CTooltip, CAlert
} from '@coreui/react'

import CIcon from '@coreui/icons-react'
import ConfirmationModal from '../modals/ConfirmationModal'
import Notify from '../../utils/Notify'
import { fn } from '../../firebase'

export default function BookItems(props) {
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [selectedBook, setSelectedBook] = useState(null)

  async function deleteBook() {
    if (!selectedBook) return

    const deleteFn = fn.httpsCallable('delete')
    try {
      const result = await deleteFn(`/books/${selectedBook.number}`)
      setShowConfirmModal(false)
      Notify.success('Book deleted successfully.')
    } catch (error) {
      setShowConfirmModal(false)
      Notify.error('Something went wrong, please try again.')
    }
  }

  return (
    <>
      <CRow className="mt-3">
        {
          props.books.map(( book) => {
            return (
              <CCol className="col-12 col-sm-6 col-md-4 col-lg-3"
                key={book.number} >
                <CCard>
                  <CCardHeader>
                    <h5><CIcon name="cil-book"></CIcon> {book.name}</h5>
                  </CCardHeader>
                  <CCardFooter>
                    <CButtonGroup className="w-100">
                      <CTooltip content="Delete Book" placement="bottom">
                        <CButton color="danger" variant="outline"
                          onClick={() => {
                            setSelectedBook(book)
                            setShowConfirmModal(true)
                          }}>
                          <CIcon name="cil-trash"></CIcon>
                        </CButton>
                      </CTooltip>
                      <CTooltip content="Edit Book" placement="bottom">
                        <CButton color="dark" variant="outline"
                          onClick={() => props.onEditClick(book)}>
                          <CIcon name="cil-pen-alt"></CIcon>
                        </CButton>
                      </CTooltip>
                      <CTooltip content="Add Chapters & Verses" placement="bottom">
                        <CButton color="success" variant="outline"
                          onClick={() => props.onAddChapterClick(book)}>
                          <CIcon name="cil-playlist-add" size="xl"></CIcon>
                        </CButton>
                      </CTooltip>
                    </CButtonGroup>
                  </CCardFooter>
                </CCard>
              </CCol>
            )
          })
        }
      </CRow>

      {
        showConfirmModal &&
        (
          <ConfirmationModal
            show={showConfirmModal}
            title={`Confirm delete "${selectedBook.name}" book?`}
            content={() =>
            (
              <>
                <CAlert color="warning" className="w-100">
                  Doing so will permanently delete this Book, including all its chapters and verses.
                </CAlert>
              </>
            )
            }
            onClose={() => {
              setShowConfirmModal(false)
            }}
            confirmText='Delete'
            onConfirm={() => {
              deleteBook()
            }}
          />
        )
      }
    </>
  )
}

